export { ListItemAvatar, ListItemAvatarProps } from './ListItemAvatar';
